import {captureException} from '@zzng/common/utils/matrix';

import {CardDetailsResponse, CardGroupResponse} from '@/root/models/card';

import {evaluateByJsonata} from '@/shared/utils/jsonata';
import {preloadImage} from '@/shared/utils/preloadImage';

const PRELOAD_CARD_COUNT = 3;

export const processCardGroup = async (cardGroup: CardGroupResponse) => {
  cardGroup.cards = await Promise.all(
    cardGroup.cards.map(async (card) => {
      card.content.title = await evaluateByJsonata(card.content.title);
      card.content.subTitle = await evaluateByJsonata(card.content.subTitle);
      card.content.info1 = await evaluateByJsonata(card.content.info1);
      card.content.info2 = await evaluateByJsonata(card.content.info2);
      card.content.badge = await evaluateByJsonata(card.content.badge);

      return card;
    })
  );

  await Promise.all(
    cardGroup.cards.slice(0, PRELOAD_CARD_COUNT).map((card) => preloadImage(card.content.backgroundImageUrl))
  ).catch((error) => {
    captureException(
      `카드 상세 이미지 preload 실패 ${cardGroup.cards
        .slice(0, PRELOAD_CARD_COUNT)
        .map((card) => card.content.backgroundImageUrl)
        .join('\n')}\n\n${JSON.stringify(error)}`
    );
  });

  return cardGroup;
};

export const processCardDetails = async (card: CardDetailsResponse) => {
  card.info = await Promise.all(
    card.info.map(async (detail) => {
      const evaluatedDetail = await evaluateByJsonata(detail);

      if (evaluatedDetail.image) {
        const preloadedImage = await preloadImage(evaluatedDetail.image).catch(() => {
          captureException(`카드 정보 이미지 preload 실패 ${evaluatedDetail.image}`);
        });
        return {
          ...evaluatedDetail,
          imageWidth: preloadedImage?.naturalWidth,
          imageHeight: preloadedImage?.naturalHeight
        };
      }

      return evaluatedDetail;
    })
  );
  return card;
};
